import type { MovieItem } from "@/types/movie";

interface TopRatedProps {
  items: MovieItem[];
}

export default function TopRated({ items }: TopRatedProps) {
  return (
    <section id="top-rated" className="scroll-mt-16 bg-foreground-950 py-14 md:py-20">
      <div className="mx-auto max-w-8xl px-4 md:px-8">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-400">
              <i className="ri-trophy-line"></i>
              口碑高分榜
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              综合评分 Top 10，值得一看的高分影视
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-background-300">
            评分综合题材完成度、讨论热度与口碑反馈整理而成，仅作挑选参考。排名靠前的作品通常制作扎实、口碑稳定。
          </p>
        </div>

        <div className="mt-8 grid gap-2.5 md:grid-cols-2 md:gap-x-10">
          {items.map((item, index) => (
            <div
              key={item.id}
              className="flex items-center gap-4 rounded-lg border border-background-50/10 bg-background-50/5 px-3 py-3 transition-colors duration-300 hover:bg-background-50/10"
            >
              <span
                className={`w-8 shrink-0 text-center font-heading text-xl font-bold ${
                  index < 3 ? "text-primary-400" : "text-background-400"
                }`}
              >
                {index + 1}
              </span>
              <div className="h-16 w-12 shrink-0 overflow-hidden rounded-md bg-foreground-800">
                <img
                  src={item.poster}
                  alt={`${item.title} 海报`}
                  title={`${item.title} 高分影视`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-background-50">{item.title}</h3>
                <p className="mt-1 truncate text-xs text-background-300">
                  {item.category} · {item.genre} · {item.year}
                </p>
              </div>
              <span className="flex shrink-0 items-center gap-1 text-sm font-bold text-primary-300">
                <i className="ri-star-fill text-xs"></i>
                {item.rating.toFixed(1)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}